import type { StandardSchemaV1 } from '@standard-schema/spec'
import type { RouteOutput, RouteOptions, RouteHandlerOptions } from './types.js'
import type { Capability } from './capability.js'

export function route<
  Cap extends Capability<StandardSchemaV1>,
  Output
> (options:RouteOptions<Cap, Output>):RouteOutput<Cap, Output> {
    return {
        cap: options.capability,
        fn: async ({ invocation, store }:RouteHandlerOptions) => {
            const { capability, handler } = options

            const args = await capability.validate(invocation.payload.args)
            if (args.issues) {
                throw new Error(args.issues.map((issue) => issue.message).join(', '))
            }

            // TODO: handle failure
            const result = await handler({ args: args.value, store })

            return result
        },
    }
}
